
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcard-orders",
      function () {
        return require("private-next-pages/giftcard-orders/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftcard-orders"])
      });
    }
  